<template>
    <div>
        <el-form inline :model="formData" @submit.native.prevent>
            <el-form-item>
                <CustomInput  label='关键词' @append-click="handleGenAppendClick('search', '输入或粘贴名称，每行一个')">
                        <ESelect
                            v-model="formData.search"
                            filterable
                            clearable
                            placeholder="输入触发维度(第一列)关键字"
                            multiple
                            collapse-tags
                            remote
                            reserve-keyword
                            :loading="searchLoading"
                            ref="search"
                            @visible-change="(val)=>handleVisibleChange(val, 'search')"
                            :remote-method="(search) => appEntrySearchList(search, 'search', {trigger_record_id: id})"
                            style="width: 250px;"
                        >
                            <p class="option-select">
                                <el-button type="text" @click="()=>handleSelectAll(search_DataList, 'search', 'all')">全选</el-button>
                                <el-button type="text" @click="()=>handleSelectAll(search_DataList, 'search', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option
                                v-for="item in search_DataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy"/>
                        </template>
                    </CustomInput>
            </el-form-item>
            <el-form-item>
                <el-button @click="()=>handleCurrentChange(1)" :loading="loading" v-matomo="{behaviorCategory: '智能托管(触发记录)',  name: `列表(触发详情-查询)` }"  type="primary">查询</el-button>
                <el-button 
                    v-matomo="{behaviorCategory: '智能托管(触发记录)',  name: `列表(触发详情-导出)` }" 
                     plain :style="{ marginBottom: '10px' }" 
                    :loading="exportLoading" @click="exportData" 
                    v-if="getCurAuth"
                >
                    导出
                </el-button>
            </el-form-item>
        </el-form>
        
        <p>
            {{condition_data}}
        </p>
        <el-table :data="tableData" style="width: 100%" stripe :header-cell-style="{ background: '#e8eaec', color: '#333' }"
            size="mini" class="create_list" v-loading="loading" tooltip-effect="dark" :max-height="tableHeight">
            <el-table-column
                :prop="column.id"
                :label="column.name"
                :min-width="index === 0 ? '240' : '180'"
                v-for="(column, index) in columns"
                :key="index"
            >
                <template slot-scope="scope">
                    <div v-html="getContent(scope.row[column.id])"></div>
                </template>
            </el-table-column>
        </el-table>
        <div class="tar pt20 pr20">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import API from '@/api/intelligent/intelligentManaged/index.js';
import HoverEllipsisTips from "@/views/workOrder/components/hoverEllipsis.vue";
import {batchSelectModal} from "@/components/modal";
import CustomInput from '@/components/CustomInput'
export default {
    name: "tiggerInfo",
    components: {HoverEllipsisTips, CustomInput},
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        pageFuncNames:Array,
        cbs: {
            type: Object,
        },
        params: {
            type: Object,
        }
    },
    data() {
        return {
            formData: {
                search: [],
            },
            dialogVisible: false,
            exportLoading: false,
            tableData: [],
            columns:[],
            condition_data: '',
            loading: false,  // 表格loading
            currentPage: 1,
            pageSize: 30,
            total: 10,
            search_DataList: [],
            searchLoading: false,
        };
    },
    watch: {

    },
    computed: {
        tableHeight(){
            return document.body.clientHeight - 400;
        },
        getCurAuth() {
            return this.pageFuncNames.includes('export');
        },
    },
    mounted() {
        this.fetchInfo()
    },
    methods: {
        handleClose() {
            // this.$emit('close');
            // this.cbs.onSubmit()
        },

        getContent(text) {
            // let ooo = '前第1日：4466.36520\n前第2日：3370.91723'
            // console.log('text', ooo.replace(/\n/g, '<br/>'))
            return text && text.replace(/\n/g, '<br/>')
        },
        fetchInfo() {
            this.loading = true
            API.getTriggerDetail({
                trigger_record_id:this.id, pn:this.currentPage, rn:this.pageSize,
                search: this.formData.search,
            }).then(res=>{
                this.columns = res.data.header

                this.total = res.data.totalCnt
                this.condition_data = res.data.condition_data

                setTimeout(()=>{
                    this.tableData= res.data.list
                    this.loading = false
                },100)

            }, err => {
                this.$message.error(err.info);
                this.loading = false
            })
        },
        exportData(){
            this.exportLoading = true;
            API.getTriggerExport({
                export:'1',
                trigger_record_id: this.id,
                search: this.formData.search,
                // pn:this.queryData.pn,
                // rn:this.queryData.rn,
            }).then(res => {
                this.exportLoading = false;
                this.$message.success(res.info||'操作成功');
            }, (err) => {
                this.exportLoading = false;
                let errData = err.data||[];
                if(err.code==0&&errData.length>0){
                    this.$notify.error({
                        title: err.info||'请求失败',
                        message: errData.join('；'),
                        duration: 0
                    });
                }else{
                    this.$message.error(err.info||'操作失败');
                }
            });
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchInfo()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchInfo()
        },
        // 下拉检索
        async appEntrySearchList(search, type, p ={}, cb) {
            try {
                const params = {
                    search,
                    plat_id: this.params.plat_id,
                    ...p
                };
                this.searchLoading = true
                const { data } = await API.postInfoSelectApi(params);
                const list = data.list;
                const errList = data.err_list;
                if (params.batch_search) {
                    cb(errList, ()=> {
                        const ids = list.map(v=>v.id)
                        this[`${type}_DataList`] = [
                            ...this[`${type}_DataList`].filter(v=>this.formData[type].includes(v.value)&&!ids.includes(v.value)),
                            ...list.map(v=> {
                                return {
                                    ...v,
                                    value: v.id,
                                    label: v.name
                                }
                            })
                        ]
                        this.formData[type] = [...new Set([ ...this.formData[type], ...ids ])];
                    })
                }else {
                    this[`${type}_DataList`]= list.map(v=> {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }
            } catch (error) {
                this.$message.warning(error.info)
            } finally {
                this.searchLoading = false
            }
        },
        handleGenAppendClick(type, placeholder) {
            const onSubmit = (data, callback)=> {
                if (data.length === 0) {
                    callback();
                    this.$message.error('请输入或粘贴名称');
                    return
                }
                this.appEntrySearchList(
                    '',
                    type,
                    {
                        batch_search: data,
                        trigger_record_id: this.id
                    },
                    (errs, cb)=> {
                        callback();
                        if (errs.length) {
                            delErrList({
                                tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                list: errs,
                                onOk: ()=> {
                                    cb();
                                    vm.close();
                                }
                            })
                        }else {
                            cb();
                            vm.close();
                        }
                    }
                )
            }
            const { vm, delErrList } = batchSelectModal({
                title: '批量添加',
                props: {
                    tip: placeholder ? placeholder : '输入或粘贴名称，每行一个',
                    hasLoading: true
                },
                cbs: {
                    onSubmit
                }
            })
        },
        handleVisibleChange(visible, type) {
            if (visible) {
                const options = this.$refs[type].selected|| [];
                const listData = options.map(v=> {
                    return v.$options.propsData
                });
                this.$set(this, `${type}_DataList`, listData)
            }
        },
        handleSelectAll(list, type, selectType) {
            if(selectType === 'all') {
                const data = [...(this.formData[type] || [])];
                data.push(...list.map(v=>v.value));
                // 去重 赋值
                this.formData[type] = [ ...new Set(data)]
            }else{
                let optionList_ids = this[`${type}_DataList`].map(item=>item.value)
                let channel_ids = this.formData[type].filter(item=> !optionList_ids.includes(item))
                this.formData[type] = [...channel_ids]
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.top-tool-bar {
    padding-left: 150px;

    .check-all-btn {
        display: inline-block;
        text-indent: 10px;
        cursor: pointer;
    }
}

.form-wrap {
    max-height: 300px;
    overflow-y: auto;
}

.width120 {
    width: 150px;
}

.mb6 {
    margin-bottom: 6px !important;
}
</style>
